<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="1100px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja zbiorcza komponentów
                </h1>
            </v-card-title>

            <v-data-table
                :headers="headers"
                :items="components"
                :mobile-breakpoint="0"
                hide-default-footer
                disable-pagination
                :loading="loading"
                loading-text="Ładowanie..."
                name="parallelComponentsData"
            >
                <template #item.productName="{item}">
                    {{ item.productName }}
                </template>
                <template #item.foldingType="{item}">
                    {{ foldingTypeName(item.foldingType) }}
                </template>
                <template #item.component="{item}">
                    {{ item.component }}
                </template>
                <template #item.parts="{item}">
                    {{ item.parts }}
                </template>
                <template #item.nettoAmount="{item}">
                    {{ item.nettoAmount }}
                </template>
                <template #item.impositionTaskId="{item}">
                    <v-select
                        :value="item.impositionTaskId"
                        :items="processOptions"
                        item-value="value"
                        item-text="text"
                        outlined
                        dense
                        hide-details
                        data-sentry-label="Przypisanie komponentu do procesu"
                        @change="changeProcess(item, $event)"
                    />
                </template>
            </v-data-table>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="actionLoading"
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ParallelComponentsDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        componentsData: {
            type: Array,
            default: () => []
        },
        processOptions: {
            type: Array,
            default: () => []
        },
        actionLoading: {
            type: Boolean
        },
        loading: {
            type: Boolean
        }
    },
    data() {
        return {
            components: [],
            headers: [
                {
                    text: 'Nazwa produktu',
                    value: 'productName',
                    sortable: false,
                },
                {
                    text: 'Rodzaj składania',
                    value: 'foldingType',
                    sortable: false,
                },
                {
                    text: 'Komponent',
                    value: 'component',
                    sortable: false,
                },
                {
                    text: 'Ilość użytków',
                    value: 'parts',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Nakład',
                    value: 'nettoAmount',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Proces',
                    value: 'impositionTaskId',
                    sortable: false,
                    align: 'center',
                    width: 320
                }
            ]
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.components = this.componentsData.map(component => ({ ...component }))
            } else {
                setTimeout(() => {
                    this.components = []
                }, 500)
            }
        },
        componentsData: {
            deep: true,
            handler(value) {
                if (this.isOpen) {
                    this.components = value.map(component => ({ ...component }))
                }
            }
        }
    },
    methods: {
        foldingTypeName(foldingType) {
            if (!foldingType) return ''

            return typeof foldingType === 'object' ? foldingType.name : foldingType
        },
        changeProcess(component, impositionTaskId) {
            component.impositionTaskId = impositionTaskId
        },
        onSave() {
            const payload = this.components.map(component => ({
                id: component.id,
                impositionTaskId: component.impositionTaskId
            }))

            this.$emit('on-save', payload)
        },
        onClose() {
            if (!this.actionLoading) {
                this.$emit('on-close')
            }
        }
    }
}
</script>
